<div mat-dialog-title class="search-detail__header">
  <div class="search-detail__header-text">
    {{ dj2DetailData.searchResponse?.primary_name }}
    <span class="search-detail__sub-heading">
      (#{{ dj2DetailData.searchResponse?.dj_id }})
    </span>
  </div>
  <div class="search-detail__close" (click)="closeDialog()">
    <img class="themified-white-icon search-detail__close-icon" src="/assets/icons/cross-icon.png" />
  </div>
</div>

<div mat-dialog-content class="search-detail__content">

  <!-- DATE DETAILS-->
  <ng-container *ngIf="dj2DetailData.searchResponse['last-review-date']">
    <div class="search-detail__column">
      <div class="search-detail__title">
        LAST REVIEW DATE
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__item_md3">
          <ng-container *ngIf="dj2DetailData.searchResponse['last-review-date']; else emptyLastReviewDate">
            <span class="search-detail__item-text">{{ dj2DetailData.searchResponse['last-review-date'] | date:'dd/MM/yyyy' }}</span>
          </ng-container>
          <ng-template #emptyLastReviewDate>
            <span>-</span>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="(dj2DetailData.searchResponse['entity-name-details'] && dj2DetailData.searchResponse['entity-name-details'].length > 0)
      || (dj2DetailData.searchResponse.person_name_details && ((dj2DetailData.searchResponse.person_name_details | json) != '{}'))">
    <div class="search-detail__column">
      <div class="search-detail__title">
        NAME DETAILS
      </div>
      <div class="wrap-table">
        <div class="table">
          <ng-container>
            <div class="table__heading">
              <div class="search-detail__item table__cell">
                <span class="search-detail__item-name">
                  Type
                </span>
              </div>
              <div class="search-detail__item table__cell">
                <ng-container *ngIf="recordType === 'CORPORATE'; else Individual">
                  <span class="search-detail__item-name">
                    Prefix
                  </span>
                </ng-container>
                <ng-template #Individual>
                  <span class="search-detail__item-name">
                    Title
                  </span>
                </ng-template>
              </div>
              <div class="search-detail__item table__cell">
                <span class="search-detail__item-name">
                  Name
                </span>
              </div>
              <div class="search-detail__item table__cell">
                <span class="search-detail__item-name">
                  Suffix
                </span>
              </div>
              <div class="search-detail__item table__cell">
                <span class="search-detail__item-name">
                  Spelling Variations
                </span>
              </div>
              <div class="search-detail__item table__cell">
                <span class="search-detail__item-name">
                  Original Script Name
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="recordType === 'CORPORATE'; else isIndividual">
            <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse['entity-name-details']">
              <div class="table__row">
                <div class="search-detail__item table__cell">
                  {{ item['name-type'] || '-' }}
                </div>
                <div class="search-detail__item table__cell">
                  {{ item.prefix || '-' }}
                </div>
                <div class="search-detail__item table__cell">
                  {{ item['entity-name'] || '-' }}
                </div>
                <div class="search-detail__item table__cell">
                  {{ item.suffix || '-' }}
                </div>
                <div class="search-detail__item table__cell">
                  <ng-container *ngIf="item['spelling-variation'] && (item['spelling-variation'].length > 0); else emptySpellingVariationsCorporate">
                    <ng-container *ngFor="let spellingVariations of item['spelling-variation']; let i = index">
                      <span>{{spellingVariations['entity-name']}}</span>
                      <span *ngIf="i !== ( item['spelling-variation'].length - 1)">, </span>
                    </ng-container>
                  </ng-container>
                  <ng-template #emptySpellingVariationsCorporate><span>-</span></ng-template>
                </div>
                <div class="search-detail__item table__cell">
                  {{ item['original-script-name']?.text}}
                  <ng-container *ngIf="item['original-script-name'] && (item['original-script-name'].length > 0); else emptyOriginalScriptNameCorporate">
                    <ng-container *ngFor="let originalScriptName of item['original-script-name']; let i = index">
                      <span>{{originalScriptName.text}}</span>
                      <span *ngIf="i !== ( item['original-script-name'].length - 1)">, </span>
                    </ng-container>
                  </ng-container>
                  <ng-template #emptyOriginalScriptNameCorporate><span>-</span></ng-template>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #isIndividual>
            <ng-container *ngFor="let item of dj2DetailData.searchResponse.person_name_details | keyvalue">
              <ng-container *ngFor="let value of item.value">
                <div class="table__row">
                  <div class="search-detail__item table__cell">
                    {{ value['name-type'] || '-' }}
                  </div>
                  <div class="search-detail__item table__cell">
                    {{ value['title-honorific'] || '-' }}
                  </div>
                  <div class="search-detail__item table__cell">
                    <ng-container *ngIf="value['first-name'] || value['middle-name'] || value['surname']; else emptyName">
                      {{ value['first-name']}} {{value['middle-name']}} {{value['surname']}}
                    </ng-container>
                    <ng-template #emptyName>-</ng-template>
                  </div>
                  <div class="search-detail__item table__cell">
                    {{ value.suffix || '-' }}
                  </div>
                  <div class="search-detail__item table__cell">
                    <ng-container *ngIf="value['spelling-variation'] && (value['spelling-variation'].length > 0); else emptySpellingVariationsIndividual">
                      <ng-container *ngFor="let spellingVariations of value['spelling-variation']; let i = index">
                        <span>{{spellingVariations['first-name']}} {{spellingVariations['surname']}}</span>
                        <span *ngIf="i !== ( value['spelling-variation'].length - 1)">, </span>
                      </ng-container>
                    </ng-container>
                    <ng-template #emptySpellingVariationsIndividual><span>-</span></ng-template>
                  </div>
                  <div class="search-detail__item table__cell">
                    {{ value['original-script-name']?.text}}
                    <ng-container *ngIf="value['original-script-name'] && (value['original-script-name'].length > 0); else emptyOriginalScriptNameIndividual">
                      <ng-container *ngFor="let originalScriptName of value['original-script-name']; let i = index">
                        <span>{{originalScriptName.text}}</span>
                        <span *ngIf="i !== ( value['original-script-name'].length - 1)">, </span>
                      </ng-container>
                    </ng-container>
                    <ng-template #emptyOriginalScriptNameIndividual><span>-</span></ng-template>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- RISKS-->
  <ng-container *ngIf="dj2DetailData.searchResponse?.risk_icons?.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        RISKS
      </div>
      <div class="search-detail__text">
        <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.risk_icons">
          <div class="search-detail__item search-detail__item_md3">
            <span class="search-detail__item-text">{{ item['iconHint'] }}</span>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- ADDRESS DETAILS -->
  <ng-container
    *ngIf="dj2DetailData.searchResponse?.address_details && dj2DetailData.searchResponse?.address_details.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        ADDRESS DETAILS
      </div>
      <div class="wrap-table">
        <div class="table">
          <ng-container>
          <div class="table__heading">
            <div class="search-detail__item  table__cell"><span class="search-detail__item-name">City</span>
            </div>
            <div class="search-detail__item  table__cell"><span class="search-detail__item-name">Country</span>
            </div>
            <div class="search-detail__item  table__cell"><span class="search-detail__item-name">Region</span>
            </div>
            <div class="search-detail__item  table__cell"><span
                class="search-detail__item-name">Zip Code</span></div>
            <div class="search-detail__item  table__cell"><span
                class="search-detail__item-name">Address URL</span></div>
            <div class="search-detail__item  table__cell"><span
                class="search-detail__item-name">Address Line</span></div>
          </div>
          </ng-container>
          <ng-template ngFor let-addressDetail [ngForOf]="dj2DetailData.searchResponse?.address_details">
            <div class="table__row">
              <div class="search-detail__item table__cell">
                {{ addressDetail.city ? addressDetail.city : '-' }}
              </div>
              <div class="search-detail__item table__cell">
                {{ addressDetail.country ? addressDetail.country : '-' }}
              </div>
              <div class="search-detail__item table__cell">
                <span *ngIf="addressDetail['region'] || addressDetail['sub-region']; else emptyRegionAddress">{{
                  addressDetail['region'] }} {{ addressDetail['sub-region'] }}</span>
                <ng-template #emptyRegionAddress><span>-</span></ng-template>
              </div>
              <div class="search-detail__item table__cell">
                {{ addressDetail['zip-code'] ? addressDetail['zip-code'] : '-' }}
              </div>
              <div class="search-detail__item table__cell">
                <ng-container *ngIf="addressDetail['address-url']; else emptyAddressUrl">
                  <a class="link link_underlined" [href]="addressDetail['address-url']">{{addressDetail['address-url']}}</a>
                </ng-container>
                <ng-template #emptyAddressUrl><span>-</span></ng-template>
              </div>
              <div class="search-detail__item table__cell">
                {{ addressDetail['address-line'] || '-' }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ADDITIONAL DETAILS -->
  <ng-container *ngIf="dj2DetailData.searchResponse?.countries && dj2DetailData.searchResponse?.countries.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        ADDITIONAL DETAILS
      </div>
      <div class="search-detail__text">
        <ng-template ngFor let-country [ngForOf]="dj2DetailData.searchResponse?.countries">
          <div class="search-detail__item search-detail__item_md4">
            <span *ngFor="let c of country | keyvalue">
              <span class="search-detail__item-name">{{c.key}}: </span>{{c.value}}
            </span>
          </div>
        </ng-template>
        <ng-container
          *ngIf="dj2DetailData.searchResponse?.date_details && dj2DetailData.searchResponse?.date_details.length > 0">
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.date_details">
            <div class="search-detail__item search-detail__item_md4">
              <span class="search-detail__item-name">{{ item['date-type'] }}:</span>
              <span class="search-detail__item-text">{{ item['date'] }}</span>
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="dj2DetailData.searchResponse?.birth_place_details && dj2DetailData.searchResponse?.birth_place_details.length > 0">
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.birth_place_details">
            <div class="search-detail__item search-detail__item_md4">
              <span class="search-detail__item-name">Birth Place Details:</span>
              <span class="search-detail__item-text">{{ item['place-name'] || '-' }}, {{ item['sub-region'] || '-' }}, {{ item['region'] || '-' }}, {{ item['country'] || '-' }}</span>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Roles -->
  <ng-container *ngIf="dj2DetailData.searchResponse?.associates && dj2DetailData.searchResponse?.associates.length > 0">
    <div class="search-detail__column">
      <div class="search-detail__title">
        KNOWN ASSOCIATES
      </div>
      <div class="wrap-table">
        <div class="table">
          <ng-container>
          <div class="table__heading">
            <div class="search-detail__item table__cell"><span class="search-detail__item-name">DJ Id</span></div>
            <div class="search-detail__item table__cell"><span class="search-detail__item-name">Name</span></div>
            <div class="search-detail__item table__cell"><span class="search-detail__item-name">Relationship</span></div>
            <div class="search-detail__item table__cell"><span class="search-detail__item-name">Previous</span></div>
            <div class="search-detail__item table__cell"><span class="search-detail__item-name">Description 1</span></div>
            <div class="search-detail__item table__cell"><span class="search-detail__item-name">Description 2</span></div>
          </div>
          </ng-container>
          <ng-template ngFor let-associate [ngForOf]="dj2DetailData.searchResponse?.associates">
            <div class="table__row">
              <div class="search-detail__item table__cell">
                {{ associate['dj-id'] || '-' }}
              </div>
              <div class="search-detail__item table__cell">
                {{ associate['primary-name'] || '-' }}
              </div>
              <div class="search-detail__item table__cell">
                {{ associate.relationship || '-' }}
              </div>
              <div class="search-detail__item table__cell">
                {{ associate.ex || '-' }}
              </div>
              <div class="search-detail__item table__cell">
                {{ associate.description1 || '-' }}
              </div>
              <div class="search-detail__item table__cell">
                {{ associate.description2 || '-' }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- WATCHLIST CONTENT -->
  <ng-container *ngIf="dj2DetailData.searchResponse?.watchlist_content">

    <!-- PROFILE NOTES -->
    <div class="search-detail__column"
      *ngIf="dj2DetailData.searchResponse?.watchlist_content && dj2DetailData.searchResponse?.watchlist_content['profile-notes']">
      <div class="search-detail__title">
        PROFILE NOTES
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__first-column">
          {{ dj2DetailData.searchResponse?.watchlist_content['profile-notes'] }}
        </div>
      </div>
    </div>

    <!-- WATCHLIST ACTIVE STATUS-->
    <div class="search-detail__column" *ngIf="dj2DetailData.searchResponse?.watchlist_content && dj2DetailData.searchResponse?.watchlist_content['active-status']">
      <div class="search-detail__title">
        WATCHLIST ACTIVE STATUS
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__first-column">
          {{ dj2DetailData.searchResponse?.watchlist_content['active-status'] }}
        </div>
      </div>
    </div>

    <!-- DESCRIPTIONS -->
    <div class="search-detail__column" *ngIf="dj2DetailData.searchResponse?.watchlist_content?.descriptions">
      <div class="search-detail__title">
        DESCRIPTIONS
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__first-column"
          *ngFor="let descriptions of dj2DetailData.searchResponse.watchlist_content.descriptions">
          <span *ngFor="let item of descriptions | keyvalue">
            <div class="search-detail__item search-detail__item_md12">
              <span class="search-detail__item-name">{{item.key}}: </span> {{item.value}}
            </div>
          </span>
        </div>
      </div>
    </div>

    <!-- OTHER ROLES AND PREVIOUS ROLES -->
    <div class="search-detail__column"
      *ngIf="dj2DetailData.searchResponse?.watchlist_content['role-details'] && dj2DetailData.searchResponse?.watchlist_content['role-details'].length > 0">
      <div class="search-detail__title" *ngIf="isShowSection.iShowPrimaryOccupation">
        Primary Occupation
      </div>
      <div class="wrap-table" *ngIf="isShowSection.iShowPrimaryOccupation">
        <div class="table">
          <div class="table__heading">
            <div class="search-detail__item-header table__cell table__cell_md4">
              Occupation
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              Occupation Category
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              From
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              To
            </div>
          </div>
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.watchlist_content['role-details']">
            <ng-container *ngIf="item['role-type'] === 'Primary Occupation'">
              <div class="table__row">
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['occupation-title'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['occupation-category'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['since-day'] || '-' }}/{{ item['since-month'] || '-' }}/{{ item['since-year'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['to-day'] || '-' }}/{{ item['to-month'] || '-' }}/{{ item['to-year'] || '-' }}
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>

      <div class="search-detail__title" *ngIf="isShowSection.isShowOtherRoles">
        Other Roles
      </div>
      <div class="wrap-table" *ngIf="isShowSection.isShowOtherRoles">
        <div class="table">
          <div class="table__heading">
            <div class="search-detail__item-header table__cell table__cell_md4">
              Occupation
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              Occupation Category
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              From
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              To
            </div>
          </div>
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.watchlist_content['role-details']">
            <ng-container *ngIf="item['role-type'] !== 'Previous Roles' && item['role-type'] !== 'Primary Occupation'">
              <div class="table__row">
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['occupation-title'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['occupation-category'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['since-day'] || '-' }}/{{ item['since-month'] || '-' }}/{{ item['since-year'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['to-day'] || '-' }}/{{ item['to-month'] || '-' }}/{{ item['to-year'] || '-' }}
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>

      <div class="search-detail__title" *ngIf="isShowSection.isShowPreviousRoles">
        Previous Roles
      </div>
      <div class="wrap-table" *ngIf="isShowSection.isShowPreviousRoles">
        <div class="table">
          <div class="table__heading">
            <div class="search-detail__item-header table__cell table__cell_md4">
              Occupation
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              Occupation Category
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              From
            </div>
            <div class="search-detail__item-header table__cell table__cell_md4">
              To
            </div>
          </div>
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.watchlist_content['role-details']">
            <ng-container *ngIf="item['role-type'] === 'Previous Roles'">
              <div class="table__row">
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['occupation-title'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['occupation-category'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['since-day'] || '-' }}/{{ item['since-month'] || '-' }}/{{ item['since-year'] || '-' }}
                </div>
                <div class="search-detail__item table__cell table__cell_md4">
                  {{ item['to-day'] || '-' }}/{{ item['to-month'] || '-' }}/{{ item['to-year'] || '-' }}
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- SANCTION REFERENCES DETAILS -->
    <div class="search-detail__column" *ngIf="dj2DetailData.searchResponse?.watchlist_content && dj2DetailData.searchResponse?.watchlist_content['sanctions-references-details']
      && dj2DetailData.searchResponse?.watchlist_content['sanctions-references-details'].length > 0">
      <div class="search-detail__title">
        SANCTION REFERENCES DETAILS
      </div>
      <div class="wrap-table">
        <div class="table">
          <div class="table__heading">
            <div class="search-detail__item-header table__cell table__cell_md5">
              Name
            </div>
            <div class="search-detail__item-header table__cell table__cell_md5">
              Description
            </div>
            <div class="search-detail__item-header table__cell table__cell_md5">
              Status
            </div>
            <div class="search-detail__item-header table__cell table__cell_md5">
              Year From
            </div>
            <div class="search-detail__item-header table__cell table__cell_md5">
              Year To
            </div>
          </div>
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse?.watchlist_content['sanctions-references-details']">
            <div class="table__row">
              <div class="search-detail__item table__cell table__cell_md5">
                {{ item['list-reference-text'] || '-' }}
              </div>
              <div class="search-detail__item table__cell table__cell_md5">
                {{ item['description2'] || '-' }}
              </div>
              <div class="search-detail__item table__cell table__cell_md5">
                {{ item['status'] || '-' }}
              </div>
              <div class="search-detail__item table__cell table__cell_md5">
                {{ item['since-day'] || '-' }}/{{ item['since-month'] || '-' }}/{{ item['since-year'] || '-' }}
              </div>
              <div class="search-detail__item table__cell table__cell_md5">
                {{ item['to-day'] || '-' }}/{{ item['to-month'] || '-' }}/{{ item['to-year'] || '-' }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  <!-- ADVERSE MEDIA-->
  <ng-container
    *ngIf="dj2DetailData.searchResponse['adverse-media-content'] && !(dj2DetailData.searchResponse['adverse-media-content'].length === 0)">
    <div class="search-detail__column">
      <div class="search-detail__title">
        ADVERSE MEDIA
      </div>
      <ng-container *ngFor="let items of dj2DetailData.searchResponse['adverse-media-content'] | keyvalue">
        <div class="search-detail__text"
          *ngIf="items.key === 'active-status' || items.key === 'profile-notes' || items.key === 'content-notice'">
          <span class="search-detail__item-header">{{items.key}}:</span>
          <span>{{items.value || '-'}}</span>
        </div>
      </ng-container>

      <!-- DESCRIPTIONS -->
      <ng-container
        *ngIf="dj2DetailData.searchResponse['adverse-media-content'].descriptions && (dj2DetailData.searchResponse['adverse-media-content'].descriptions.length > 0)">
        <div class="search-detail__title search-detail__sub-title">Descriptions</div>
        <div class="search-detail__text">
          <ng-container>
            <div class="search-detail__item-header search-detail__item_md4">
              Description 1
            </div>
            <div class="search-detail__item-header search-detail__item_md4">
              Description 2
            </div>
            <div class="search-detail__item-header search-detail__item_md4">
              Description 3
            </div>
          </ng-container>
          <ng-container *ngFor="let item of dj2DetailData.searchResponse['adverse-media-content'].descriptions">
            <!-- {{ item | json}} -->
            <div class="search-detail__item search-detail__item_md4">
              {{ item['description1'] }}
            </div>
            <div class="search-detail__item search-detail__item_md4">
              {{ item['description2'] }}
            </div>
            <div class="search-detail__item search-detail__item_md4">
              {{ item['description3'] }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <!-- SOURCE DETAILS -->
      <ng-container
        *ngIf="dj2DetailData.searchResponse['adverse-media-content']['source-details'] && (dj2DetailData.searchResponse['adverse-media-content']['source-details'].length > 0)">
        <div class="search-detail__column">
          <div class="search-detail__title search-detail__sub-title">Source Details:</div>
          <div class="search-detail__text">
            <div class="search-detail__item search-detail__item_md12"
              *ngFor="let item of dj2DetailData.searchResponse['adverse-media-content']['source-details']">
              <ng-container *ngIf="isTextValid(item); else isTextInvalid">
                <a class="link link_underlined" target="_blank" [href]="convertUrlWithAscensionNumber(item)">{{ item }}</a>
              </ng-container>
              <ng-template #isTextInvalid>
                <a target="_blank">{{ item }}</a>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ADVERSE MEDIA DETAILS -->
      <ng-container
        *ngIf="dj2DetailData.searchResponse['adverse-media-content']['adverse-media-details'] && (dj2DetailData.searchResponse['adverse-media-content']['adverse-media-details'].length > 0)">

        <!-- DOW JONES COMMENT -->
        <ng-container *ngIf="isShowSection.isShowDowJonesComment">
          <div class="search-detail__title search-detail__title--custom">Dow Jones Comment</div>
          <div class="search-detail__text"
              *ngFor="let data of dj2DetailData.searchResponse['adverse-media-content']['adverse-media-details']">
              <div>{{ data['dowjones-comment']}} </div>
            </div>
        </ng-container>

        <!-- ADVERSE MEDIA ITEM -->
        <ng-container>
          <div class="search-detail__title search-detail__title--custom">Reported Allegation</div>
          <div class="wrap-table">
            <div class="table">
              <div class="table__heading">
                <div class="search-detail__item-header table__cell table__cell_md3">Description 2</div>
                <div class="search-detail__item-header table__cell table__cell_md3">Description 3</div>
                <div class="search-detail__item-header table__cell table__cell_md3">Government Action</div>
              </div>
              <ng-container *ngFor="let data of dj2DetailData.searchResponse['adverse-media-content']['adverse-media-details']">
                <ng-container *ngFor="let item of data['adverse-media-item']">
                  <ng-container *ngFor="let element of item['reported-allegation']">
                    <div class="table__row">
                      <div class="search-detail__item table__cell table__cell_md3">
                        {{ element['description2'] }}
                      </div>
                      <div class="search-detail__item table__cell table__cell_md3">
                        {{ element['description3'] }}
                      </div>
                      <div class="search-detail__item table__cell table__cell_md3">
                        {{ element['government-action'] }}
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- ADVERSE MEDIA SOURCE -->
        <ng-container>
          <div class="search-detail__title search-detail__title--custom">Adverse Media Source</div>
          <div class="wrap-table">
            <div class="table">
              <div class="table__heading">
                <div class="search-detail__item-header table__cell table__cell_md4">Date</div>
                <div class="search-detail__item-header table__cell table__cell_md4">Name</div>
                <div class="search-detail__item-header table__cell table__cell_md4">Language</div>
              </div>
              <ng-container *ngFor="let data of dj2DetailData.searchResponse['adverse-media-content']['adverse-media-details']">
                <ng-container *ngFor="let item of data['adverse-media-item']">
                  <ng-container *ngFor="let element of item['adverse-media-source']">
                    <div class="table__row">
                      <div class="search-detail__item table__cell table__cell_md3">
                        {{ element['date'] || '-' }}
                      </div>
                      <div class="search-detail__item table__cell table__cell_md3">
                        {{ element['name'] }}
                      </div>
                      <div class="search-detail__item table__cell table__cell_md3">
                        {{ element['language'] }}
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <!-- STATE OWNED COMPANY -->
  <ng-container
    *ngIf="dj2DetailData.searchResponse?.state_owned_companies_content && !(dj2DetailData.searchResponse?.state_owned_companies_content.length === 0); let stateOwnedCompaniesContent">
    <div class="search-detail__column">
      <div class="search-detail__title">
        STATE OWNED COMPANY
      </div>
      <div class="search-detail__text"
        *ngIf="dj2DetailData.searchResponse?.state_owned_companies_content; let stateOwnedCompaniesContent">
        <div class="search-detail__item search-detail__item_md12" *ngIf="stateOwnedCompaniesContent['active-status']">
          <span class="search-detail__item-name">Active Status: </span> {{stateOwnedCompaniesContent['active-status']}}
        </div>
        <div class="search-detail__item search-detail__item_md12" *ngIf="stateOwnedCompaniesContent.descriptions && stateOwnedCompaniesContent.descriptions.length > 0">
          <span class="search-detail__item-name">Category 1: </span>
          <ng-container *ngFor="let descriptions of stateOwnedCompaniesContent.descriptions; let i = index">
            <span>{{descriptions.description1}}</span>
            <span *ngIf="i !== ( stateOwnedCompaniesContent.descriptions.length - 1)">, </span>
          </ng-container>
        </div>
        <div class="search-detail__item search-detail__item_md12" *ngIf="stateOwnedCompaniesContent.descriptions && stateOwnedCompaniesContent.descriptions.length > 0">
          <span class="search-detail__item-name">Category 2: </span>
          <ng-container *ngFor="let descriptions of stateOwnedCompaniesContent.descriptions; let i = index">
            <span>{{descriptions.description2}}</span>
            <span *ngIf="i !== ( stateOwnedCompaniesContent.descriptions.length - 1)">, </span>
          </ng-container>
        </div>
        <ng-container *ngIf="stateOwnedCompaniesContent['stake-level-details'] && (stateOwnedCompaniesContent['stake-level-details'].length > 0)">
          <div class="search-detail__title search-detail__title--custom">Control</div>
          <div class="wrap-table">
            <div class="table">
              <div class="table__heading">
                <div class="search-detail__item-header table__cell table__cell_md4"></div>
                <div class="search-detail__item-header table__cell table__cell_md4">Since</div>
                <div class="search-detail__item-header table__cell table__cell_md4">To</div>
                <div class="search-detail__item-header table__cell table__cell_md4">Notes</div>
              </div>
              <ng-container *ngFor="let stateLevelDetail of stateOwnedCompaniesContent['stake-level-details']">
                <div class="table__row">
                  <div class="search-detail__item table__cell table__cell_md4">
                    <div class="search-detail__item-header" *ngIf="stateLevelDetail['stake-level-1']">{{ stateLevelDetail['stake-level-1'] || '-' }}</div>
                    <div [ngClass]="{'search-detail__item-header':  stateLevelDetail['stake-level-3']}" *ngIf="stateLevelDetail['stake-level-2']">{{ stateLevelDetail['stake-level-2'] || '-' }}</div>
                    <ng-container>
                      <span>{{ stateLevelDetail['stake-level-3'] }}</span>
                      <span *ngIf="stateLevelDetail['stake-level-3'] && stateLevelDetail['ownership-percentage']"> - </span>
                      <span>{{ stateLevelDetail['ownership-percentage'] }}</span>
                      </ng-container>
                  </div>
                  <div class="search-detail__item table__cell table__cell_md4">
                    {{ stateLevelDetail['since-day'] || '-' }}/{{ stateLevelDetail['since-month'] || '-' }}/{{ stateLevelDetail['since-year'] || '-' }}
                  </div>
                  <div class="search-detail__item table__cell table__cell_md4">
                    {{ stateLevelDetail['to-day'] || '-' }}/{{ stateLevelDetail['to-month'] || '-' }}/{{ stateLevelDetail['to-year'] || '-' }}
                  </div>
                  <div class="search-detail__item table__cell table__cell_md4">
                    {{ stateLevelDetail['stake-level-notes'] || '-'}}
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="stateOwnedCompaniesContent['djii-industry-details'] && (stateOwnedCompaniesContent['djii-industry-details'].length > 0)">
          <div class="search-detail__title search-detail__title--custom">DJII Industry Details</div>
          <div class="wrap-table">
            <div class="table">
              <div class="table__heading">
                <div class="search-detail__item-header table__cell table__cell_md4">ID</div>
                <div class="search-detail__item-header table__cell table__cell_md4">Industry</div>
                <div class="search-detail__item-header table__cell table__cell_md4">Description</div>
              </div>
              <ng-container *ngFor="let djiiIndustryDetai of stateOwnedCompaniesContent['djii-industry-details']">
                <div class="table__row">
                  <div class="search-detail__item table__cell table__cell_md4">
                    {{ djiiIndustryDetai['djii-industry-id'] || '-' }}
                  </div>
                  <div class="search-detail__item table__cell table__cell_md4">
                    {{ djiiIndustryDetai['description'] || '-' }}
                  </div>
                  <div class="search-detail__item table__cell table__cell_md4">
                    {{ djiiIndustryDetai['djii-industry'] || '-'}}
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <div class="search-detail__item search-detail__item_md12" *ngIf="stateOwnedCompaniesContent['profile-notes']">
          <span class="search-detail__item-name">Profile notes: </span> {{stateOwnedCompaniesContent['profile-notes']}}
        </div>
        <div class="search-detail__item search-detail__item_md12" *ngIf="stateOwnedCompaniesContent['content-notice']">
          <span class="search-detail__item-name">Content notice: </span>
          {{stateOwnedCompaniesContent['content-notice']}}
        </div>
      </div>
    </div>
  </ng-container>

  <!-- IDENTIFICATION DETAILS -->
  <ng-container
    *ngIf="dj2DetailData.searchResponse?.identification_details && (dj2DetailData.searchResponse?.identification_details.length > 0)">
    <div class="search-detail__column">
      <div class="search-detail__title">
        IDENTIFICATION DETAILS
      </div>
      <div class="wrap-table">
        <div class="table">
          <div class="table__heading">
            <div class="search-detail__item-header table__cell table__cell_md3">Id Type</div>
            <div class="search-detail__item-header table__cell table__cell_md3">Id Number</div>
            <div class="search-detail__item-header table__cell table__cell_md3">Id Notes</div>
          </div>
          <ng-template ngFor let-identificationDetail [ngForOf]="dj2DetailData.searchResponse?.identification_details">
            <div class="table__row">
              <div class="search-detail__item table__cell table__cell_md3">
                {{ identificationDetail['identification-type'] || '-' }}
              </div>
              <div class="search-detail__item table__cell table__cell_md3">
                {{identificationDetail['identification-number'] || '-' }}
              </div>
              <div class="search-detail__item table__cell table__cell_md3">
                {{identificationDetail['identification-notes'] || '-' }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

    <!-- SUPPORTING DOCUMENTS -->
    <ng-container
      *ngIf="dj2DetailData.searchResponse['image-details'] && dj2DetailData.searchResponse['image-details'].length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          SUPPORTING DOCUMENTS
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="dj2DetailData.searchResponse['image-details']">
            <div class="search-detail__item search-detail__item_md12">
              <a class="link link_underlined" target="_blank" href="{{item}}">{{ item }}</a>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- SOURCE DETAILS -->
    <div class="search-detail__column"
      *ngIf="dj2DetailData.searchResponse?.watchlist_content['sources'] && dj2DetailData.searchResponse?.watchlist_content['sources'].length > 0">
      <div class="search-detail__title">
        SOURCE DETAILS
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__item_md12"
          *ngFor="let detail of dj2DetailData.searchResponse?.watchlist_content['sources']">
          <ng-container *ngIf="(detail.externalLink)">
            <a class="link link_underlined" target="_blank" href="{{ detail.externalLink }}">{{ detail['externalLink'] }}</a>
          </ng-container>
          <ng-container *ngIf="(detail.drn) || (detail.title)">
            <a class="link link_underlined" target="_blank" href="{{ 'https://global.factiva.com/redir/default.aspx?P=sa&AN=' + detail.accessionNumber }}" *ngIf="(detail.drn); else noDrn ">{{ detail['title'] }}</a>
            <ng-template #noDrn ><a target="_blank">{{ detail['title'] }}</a></ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- DOWNLOAD -->
  <div class="search-detail__column search-detail__column-action" *ngIf="dj2DetailData.scanType !== 'ODD'">
    <button ubi-round-button mat-button class="btn btn_accent-gradient-rounded" (click)="downloadPDF()">
      Download as PDF
    </button>
  </div>
</div>
